import React, {
  useEffect,
  useRef,
  useState
} from "react";
import CandidatTable from "../Candidat/ListCandidats/CandidatTable/index";
import CandidatImport from "../Import/Candidat/CandidatImport";
import { useLocation } from 'react-router-dom';
import qs from "query-string";
import { searchCandidats } from "../../services/CandidatService";
import { ContactList } from "../Contact";
import ListerSociete from "../Societe/ListerSociete";
import { rechercherSociete } from "../../services/SocieteService";
import { searchContacts } from "../../services/ContactService";
import Search from "./search";
import { updateObjectStateValue } from "../../utils/FunctionHelpers";
import { getRowsPerPage } from "../../utils/DataTables";
import { Box } from '@mui/material';
import { TABLE } from "../../enums/tablesEnum";

const Dashboard = ({
  snackbarShowMessage,
  history
}) => {
  const mounted = useRef(false);
  const [candidatsData, setCandidatsData] = useState({
    loadCandidats: false,
    pageCandidat: 1,
    candidatsCount: 0,
    candidats: [],
    isLoading: false,
    sort: {
      name: "prenom",
      direction: "asc",
    },
    limit: getRowsPerPage("candidatColumnVisibility") ?? 50
  });
  const [societesData, setSocietesData] = useState({
    loadSociete: false,
    pageSociete: 1,
    societesCount: 0,
    societes: [],
    isLoading: false,
    sort: {
      name: "nom_societe",
      direction: "asc",
    },
    limit: getRowsPerPage("societeColumnVisibility") ?? 50
  });
  const [contactsData, setContactsData] = useState({
    loadContacts: false,
    pageContact: 1,
    contactsCount: 0,
    contacts: [],
    isLoading: true,
    limit: getRowsPerPage("contactColumnVisibility") ?? 50,
    sorting: { name: '', order: 'asc' }
  });

  const [parameters, setParameters] = useState({ categorie: TABLE.CANDIDAT });
  const [aiMode, setAiMode] = useState(false);
  const [aiRows, setAiRows] = useState({ data: [], isLoading: false});
  const [importModalState, setImportModalState] = useState({ open: false });
  const handleOpenImport = () => setImportModalState({ open: true });
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      handleSearch(params);
    } else {
      handleSearch(parameters);
    }
  }, [location.search])


  const handleSearchCandidats = async (page, params = "", limit = candidatsData.limit) => {
    const isAiSearch = params?.isAiSearch === true || params?.isAiSearch === "true";
    setAiMode(isAiSearch);
    const isAgentIaSearch = isAiSearch && params?.iaMode === "agent";
    if (!isAgentIaSearch) {
      setAiRows({ data: [], isLoading: false });
    }
    setCandidatsData((prev) => ({
      ...prev,
      candidats: [],
      loadCandidats: true,
      isLoading: true,
      pageCandidat: page,
      limit
    }))
    try {
      const normalizeParams = (params) =>
        JSON.parse(JSON.stringify(params));
      
      const filteredParams = Object.fromEntries(
        Object.entries(normalizeParams(params))
          .filter(([_, value]) => value !== "" && value !== undefined)
      );

      // Keep agent IA-only params on the client side; backend search API does not use them.
      const { iaMode, agentText, ...apiParams } = filteredParams;
      const queryParams = {
        ...apiParams,
        limit,
      };

      const newCandidats = await searchCandidats(qs.stringify(queryParams, { arrayFormat: "bracket", allowDots: true }), page);
      const candidatsData = {
        loadCandidats: true,
        candidatsCount: newCandidats.data.count,
        candidats: newCandidats.data.candidats,
        isLoading: false,
        pageCandidat: newCandidats.data.page,
        sort: newCandidats.data.sort,
        limit: limit
      };

      updateObjectStateValue(setCandidatsData, candidatsData);
    } catch (error) {
      snackbarShowMessage("Erreur de chargement des candidats.", "error", 4000);
      updateObjectStateValue(setCandidatsData, {
        isLoading: false,
      });
    }
  };


  const handleSearchSocietes = (page, params = "", limit = societesData.limit) => {
    setSocietesData((prev) => ({
      ...prev,
      loadSociete: true,
      societesCount: 0,
      societes: [],
      isLoading: true,
      pageSociete: 1,
      limit
    }));

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value !== "")
    );
    const queryParams = {
      ...filteredParams,
      limit,
    };

    rechercherSociete(qs.stringify(queryParams), page).then((newSocietes) => {
      setSocietesData({
        loadSociete: true,
        societesCount: newSocietes.data.count,
        societes: newSocietes.data.societes,
        isLoading: false,
        pageSociete: newSocietes.data.page,
        sort: newSocietes.data.sort,
        limit: limit
      });
    }).catch(error => {
      snackbarShowMessage("Erreur de chargement des sociétés.", "error", 4000);
      setSocietesData({
        isLoading: false
      });
    });
  }

  const handleSearchContacts = async (page, params = "", limit = contactsData.limit) => {
    try {
      setContactsData({
        isLoading: true,
        contactsCount: 0,
        contacts: [],
        pageContact: 1,
        limit
      });

      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([key, value]) => value !== "")
      );
      const queryParams = {
        ...filteredParams,
        limit,
      };
      const { data } = await searchContacts(qs.stringify(queryParams, { arrayFormat: "bracket" }), page);
      const contactsData = {
        loadContacts: true,
        contactsCount: data.count,
        contacts: data.contacts,
        isLoading: false,
        pageContact: data.page,
        limit: limit,
        sorting: params.column ? { name: params.column, order: params.sort } : { name: '', order: 'asc' }
      };
      updateObjectStateValue(setContactsData, contactsData);
    } catch (error) {
      snackbarShowMessage("Erreur de chargement des contacts.", "error", 4000);
      setContactsData({
        isLoading: false
      });
    }
  };


  const candidatProps = {
    candidatsData,
    handleSearchCandidats,
    parameters,
  };

  const contactProps = {
    contactsData,
    handleSearchContacts,
    parameters
  };

  const societeProps = {
    societesData,
    handleSearchSocietes,
    parameters
  };

  const handleSearch = async (params) => {
    setParameters(params);
    switch (params.categorie) {
      case TABLE.CANDIDAT:
        handleSearchCandidats(candidatsData.pageCandidat, params);
        break;
      case TABLE.SOCIETE:
        handleSearchSocietes(societesData.pageSociete, params);
        break;
      case TABLE.CONTACT:
        handleSearchContacts(contactsData.pageContact, params);
        break;
      default:
        break;
    }
  };

  const handleIaActivate = (data) => {
    setAiRows(data);
    setAiMode(true);
  };
  const handleIaDeactivate = () => {
    setAiRows({data:[], isLoading: false});
    setAiMode(false);
  };

  const searchProps = {
    mounted,
    candidatsData,
    societesData,
    contactsData,
    handleSearch,
    history,
    onIaActivate: handleIaActivate,
    onIaDeactivate: handleIaDeactivate,
    snackbarShowMessage,
    onImportCandidats: handleOpenImport,
  };


  const DisplayTables = ({ props }) => {

    const { categorie } = parameters || {};
    
    if (categorie === TABLE.CANDIDAT) 
      return (
        <CandidatTable
            {...candidatProps}
            aiMode={aiMode}
            aiRows={aiRows}
        />);
    if (categorie === TABLE.CONTACT) return <ContactList {...contactProps} />;
    if (categorie === TABLE.SOCIETE) return <ListerSociete {...societeProps} />;
    return null;
  }

  return (
    <Box sx={{ padding: "0 20px" }}>
      <Search {...searchProps} />
      <Box sx={{ marginTop: "2rem" }}>
        <DisplayTables />
      </Box>
      <CandidatImport
        open={false}
        onClose={() => {}}
        modalState={importModalState}
        setModalState={setImportModalState}
        handleOpen={handleOpenImport}
      />
    </Box>
  );
};

export default Dashboard;
